var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("SimpleTextPopup", {
    attrs: { title: _vm.$t("detail"), hideRgtBtn: "", medium: "" },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            _c(
              "v-container",
              { attrs: { fluid: "" } },
              [
                _c(
                  "v-layout",
                  { attrs: { "align-center": "", "justify-center": "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs8: "", md6: "", lg5: "", xl4: "" } },
                      [_vm._v(_vm._s(_vm.$t("deposit")) + ": ")]
                    ),
                    _vm._v(" "),
                    _c("v-flex", { attrs: { xs4: "" } }, [
                      _vm._v("$ " + _vm._s(_vm.toMoney(_vm.transaction.amount)))
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { "align-center": "", "justify-center": "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs8: "", md6: "", lg5: "", xl4: "" } },
                      [_vm._v(_vm._s(_vm.$t("balance")) + ": ")]
                    ),
                    _vm._v(" "),
                    _c("v-flex", { attrs: { xs4: "" } }, [
                      _vm._v(
                        "$ " + _vm._s(_vm.toMoney(_vm.transaction.newBalance))
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { "align-center": "", "justify-center": "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs8: "", md6: "", lg5: "", xl4: "" } },
                      [_vm._v(_vm._s(_vm.$t("name")) + ": ")]
                    ),
                    _vm._v(" "),
                    _c("v-flex", { attrs: { xs4: "" } }, [
                      _vm._v(_vm._s(_vm.transaction.clientName))
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { "align-center": "", "justify-center": "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs8: "", md6: "", lg5: "", xl4: "" } },
                      [_vm._v(_vm._s(_vm.$t("transactionTime")) + ": ")]
                    ),
                    _vm._v(" "),
                    _c("v-flex", { attrs: { xs4: "" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.toTimestampString(_vm.transaction.createTime)
                        )
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { "align-center": "", "justify-center": "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs8: "", md6: "", lg5: "", xl4: "" } },
                      [_vm._v(_vm._s(_vm.$t("note")) + ": ")]
                    ),
                    _vm._v(" "),
                    _c("v-flex", { attrs: { xs4: "" } }, [
                      _vm._v(_vm._s(_vm.transaction.note || "--"))
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.transaction.attachments &&
                _vm.transaction.attachments.length
                  ? _c(
                      "v-layout",
                      { attrs: { "align-center": "", "justify-center": "" } },
                      [
                        _c(
                          "v-flex",
                          { attrs: { xs7: "", md5: "", lg4: "", xl3: "" } },
                          [_vm._v(_vm._s(_vm.$t("attachments")) + ": ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs5: "" } },
                          [
                            _c(
                              "v-layout",
                              { attrs: { row: "", wrap: "" } },
                              _vm._l(
                                _vm.transaction.attachments || [],
                                function(file, index) {
                                  return _c("FsFileChip", {
                                    key: "file" + index,
                                    attrs: {
                                      file: file,
                                      width: "100%",
                                      "aspect-ratio": "1.7"
                                    }
                                  })
                                }
                              ),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !!_vm.transaction.offlineDepositDocId
                  ? _c(
                      "v-layout",
                      { attrs: { "align-center": "", "justify-center": "" } },
                      [
                        _c(
                          "v-flex",
                          { attrs: { xs8: "", md6: "", lg5: "", xl4: "" } },
                          [_vm._v(_vm._s(_vm.$t("offlineDepositId")) + ": ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs4: "" } },
                          [
                            _vm._v(
                              _vm._s(_vm.transaction.offlineDepositDocId) +
                                "\n          "
                            ),
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "primary", small: "" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.showOfflineDepositDialog()
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("view")))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm.isShowDepositDetailDialog
              ? _c(
                  "ChatRoom",
                  _vm._b(
                    {
                      ref: "chatRoom",
                      attrs: {
                        title: _vm.$t("caseOfflineDeposit"),
                        enableFileUpload: "",
                        docPath: [
                          "depositRequests",
                          _vm.offlineDepositDetail._key ||
                            _vm.offlineDepositDetail.id
                        ],
                        comments: _vm.offlineComments,
                        readOnly: ""
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "issue",
                            fn: function() {
                              return [
                                _c(
                                  "v-card",
                                  { attrs: { hover: "", raised: "" } },
                                  [
                                    _c(
                                      "v-card-text",
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "cardTitle" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("requestID")) +
                                                ":" +
                                                _vm._s(
                                                  _vm.offlineDepositDetail
                                                    ._key ||
                                                    _vm.offlineDepositDetail.id
                                                )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "cardTitle",
                                            staticStyle: {
                                              "overflow-wrap": "break-word"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(_vm.$t("createTime")) +
                                                ": " +
                                                _vm._s(
                                                  _vm.toTimestampString(
                                                    _vm.offlineDepositDetail
                                                      .createTime
                                                  )
                                                ) +
                                                "\n            "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.warehouse
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "cardTitle",
                                                staticStyle: {
                                                  "overflow-wrap": "break-word"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(
                                                      _vm.$t("organization")
                                                    ) +
                                                    ": " +
                                                    _vm._s(
                                                      _vm.offlineDepositDetail
                                                        .orgName
                                                    ) +
                                                    "\n            "
                                                )
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass: "cardTitle",
                                                staticStyle: {
                                                  "overflow-wrap": "break-word"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(_vm.$t("vendor")) +
                                                    ": " +
                                                    _vm._s(
                                                      _vm.offlineDepositDetail
                                                        .vendorName
                                                    ) +
                                                    "\n            "
                                                )
                                              ]
                                            ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "cardTitle" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("amount")) +
                                                ": " +
                                                _vm._s(
                                                  _vm.offlineDepositDetail
                                                    .currencyType
                                                ) +
                                                _vm._s(
                                                  _vm.offlineDepositDetail
                                                    .amount
                                                )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "cardTitle" },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(_vm.$t("offlineType")) +
                                                ":" +
                                                _vm._s(
                                                  _vm.offlineDepositDetail
                                                    .offlineType
                                                ) +
                                                "\n            "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "cardTitle",
                                            staticStyle: {
                                              "overflow-wrap": "break-word"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(_vm.$t("note")) +
                                                ":" +
                                                _vm._s(
                                                  _vm.offlineDepositDetail.note
                                                ) +
                                                "\n            "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "cardTitle" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("status")) +
                                                ":" +
                                                _vm._s(
                                                  _vm.offlineDepositDetail
                                                    .status
                                                )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "cardTitle",
                                            staticStyle: {
                                              "overflow-wrap": "break-word"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  _vm.$t("lastModifiedTime")
                                                ) +
                                                ": " +
                                                _vm._s(
                                                  _vm.toTimestampString(
                                                    _vm.offlineDepositDetail
                                                      .lastModifiedTime ||
                                                      _vm.offlineDepositDetail
                                                        .createTime
                                                  )
                                                ) +
                                                "\n            "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        (
                                          _vm.offlineDepositDetail
                                            .uploadFiles || []
                                        ).length
                                          ? _c(
                                              "v-layout",
                                              { attrs: { row: "", wrap: "" } },
                                              _vm._l(
                                                _vm.offlineDepositDetail
                                                  .uploadFiles,
                                                function(file, index) {
                                                  return _c("FsFileChip", {
                                                    key: "file" + index,
                                                    staticClass: "ma-2",
                                                    attrs: {
                                                      file: file,
                                                      width: "100%",
                                                      "aspect-ratio": "1.7"
                                                    }
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        242793480
                      ),
                      model: {
                        value: _vm.isShowDepositDetailDialog,
                        callback: function($$v) {
                          _vm.isShowDepositDetailDialog = $$v
                        },
                        expression: "isShowDepositDetailDialog"
                      }
                    },
                    "ChatRoom",
                    _vm.offlineDepositDetail,
                    false
                  )
                )
              : _vm._e()
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a4e060f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4e060f0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TransactionDetailsPopup.vue
// module id = null
// module chunks = 